import React from 'react'
import { DisplayDate } from '../../../../components/_utils/appUtils'
import ReactHtmlParser from 'react-html-parser'
import { Row, Col } from 'antd'

const RowTable = (props) => {
  let { title, value } = props
  return (
    <div className={'row'}>
      <div className={'title'}>{title} :</div>
      <div style={{ marginLeft: '10px' }}>{value}</div>
    </div>
  )
}

const AbstractInfo = (props) => {
  let { abstract } = props

  return (
    <div className={'articleInfoBox'}>
      <Row>
        <Col span={12}>
          {/*<RowTable title={'Abstract ID'} value={abstract.onlineAbstractId || abstract.abstractId} />*/}

          <RowTable title={'Abstract ID'} value={abstract.abstractNo} />
        </Col>
        <Col span={12}>
          <RowTable title={'Submit Date'}
                    value={abstract.createdAt ? DisplayDate(abstract.createdAt) : null} />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <RowTable title={'Abstract Title'}
                    value={abstract.titleOfAbstract ? ReactHtmlParser(abstract.titleOfAbstract) : null} />
        </Col>
        <Col span={12}>
          <RowTable title={'Issue Type'}
                    value={abstract.issueType} />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <RowTable title={'Research Area'} value={abstract.researchArea} />
        </Col>
        <Col span={12}>
          <RowTable title={'Author Name'} value={abstract.authorName} />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <RowTable title={'Institute Affiliated'} value={abstract.institution} />
        </Col>
        <Col span={12}>
          <RowTable title={'Author Country'} value={abstract.country} />
        </Col>
      </Row>
    </div>
  )
}
export default AbstractInfo
